export default {
    COMMON_HANDLE_ERROR: 'COMMON_HANDLE_ERROR',
    COMMON_CLEAR_ERROR: 'COMMON_CLEAR_ERROR',

    COMMON_CALLBACK_ERROR: 'COMMON_CALLBACK_ERROR',
    COMMON_CALLBACK_404: 'COMMON_CALLBACK_404',
    COMMON_CALLBACK_NON_AUTH: 'COMMON_CALLBACK_NON_AUTH'
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/actions/types/common.types.js